module.exports = __webpack_public_path__ + "img/woocomerce-vertical.d0302f83.svg";